import { finish, start } from '../data/networkSlice.js';
import store from '../data/store.js';
import getUrl from '../utils/getUrl.js';
import { REQUESTS } from '../views/constants.js';
import generateAxiosInstance from './api/index.js';

const { axios, interceptors } = generateAxiosInstance({
  baseURL: '/surpas/api/'
});

interceptors.sessionTimeout();

interceptors.network({
  onStartRequest: ({ key, startTime }) => store.dispatch(start({ key, startTime })),
  onFinishRequest: ({ key, startTime, error }) => store.dispatch(finish({ key, startTime, error }))
});

export function getAbout() {
  return axios.request({
    method: 'get',
    url: `/about?at=${Date.now()}`,
    agilemdType: REQUESTS.ABOUT
  });
}

export function getGuide() {
  return axios.request({
    method: 'get',
    url: `/guide?at=${Date.now()}`,
    agilemdType: REQUESTS.GUIDE
  });
}

export function formatPatientPrintoutUrl(filename) {
  return getUrl(`/patient-printouts/${filename}`);
}

export function postEvent(type, context) {
  return axios.request({
    method: 'post',
    url: '/events',
    data: {
      type,
      context: context || {}
    },
    agilemdType: REQUESTS.EVENT
  });
}

export function postFeedback(isAnonymous, category, comments) {
  return axios.request({
    method: 'post',
    url: '/feedback',
    data: {
      isAnonymous,
      category,
      comments
    },
    agilemdType: REQUESTS.FEEDBACK
  });
}

export function postResponse(responseSet, { shouldRecordResponse = false } = {}) {
  return axios.request({
    method: 'post',
    url: '/responses',
    data: { ...responseSet, shouldRecordResponse },
    agilemdType: REQUESTS.RESPONSE
  });
}

export function postPractitionerSpecialty(specialtyId) {
  return axios.request({
    method: 'post',
    url: '/responses/specialties',
    data: { practitionerSpecialty: specialtyId },
    agilemdType: REQUESTS.PRACTITIONER_SPECIALTY
  });
}

export function searchProcedures(
  { query, limit, offset = 0, sortBy = 'frequency', sortAscending, filters = {} },
  { cancelToken } = {}
) {
  const filter = Object.entries(filters)
    .map(([key, value]) => [key, Array.isArray(value) ? value.join(',') : value])
    .reduce(
      (out, next) => ({
        ...out,
        [next[0]]: next[1]
      }),
      {}
    );

  const params = {
    ...filter,
    // [ZL] This is needed, or IE way too aggressively caches
    ts: Date.now(),
    q: query,
    limit,
    offset,
    sort: [sortBy, sortAscending ? 'asc' : 'desc'].join('-')
  };

  return axios.request({
    agilemdType: REQUESTS.LIST_PROCEDURES,
    method: 'get',
    url: `/procedures`,
    params,
    cancelToken
  });
}

export function addBookmark(cptCode) {
  return axios.request({
    method: 'post',
    url: `/profiles/procedure-bookmarks`,
    data: { cptCode },
    agilemdType: REQUESTS.ADD_BOOKMARK,
    agilemdPayload: { cptCode }
  });
}

export function removeBookmark(cptCode) {
  return axios.request({
    method: 'delete',
    url: `/profiles/procedure-bookmarks?cpt-code=${cptCode}`,
    agilemdType: REQUESTS.REMOVE_BOOKMARK,
    agilemdPayload: { cptCode }
  });
}

export function setProfilePractitionerSpecialties(specialties) {
  return axios.request({
    method: 'post',
    url: `/profiles/practitioner-specialties`,
    data: { specialties },
    agilemdType: REQUESTS.SET_PROFILE_PRACTITIONER_SPECIALTIES
  });
}
